import React, { useMemo } from "react";
import { observer } from "mobx-react";
import { Routes, Route, Navigate } from "react-router-dom";
import {
  PageContainer,
  ContentContainer,
  TitleContainer,
  Title,
  TabSwitcherContainer,
} from "./Activity.styled";
import { ButtonsList } from "@ann/web-components";
import { All, Email, Calls, SMS, Notes } from "./pages";
import { useActivityPage } from "../../hooks/useActivityPage";
import { ACTIVITY_TYPES } from "../../context/ActivityContext";

const Activity = observer(() => {
  const {
    contactId,
    activeTab,
    handleTabChange,
    getTabProps,
    currentCollection,
    handleItemsPerPageChange,
    handlePageChange,
    handleRefresh,
    handleGetNoteDetail,
    handleUpdateNote,
    handleDeleteNote,
  } = useActivityPage();

  const tabItems = useMemo(
    () => [
      {
        id: ACTIVITY_TYPES.ALL,
        label: "All",
      },
      {
        id: ACTIVITY_TYPES.EMAIL,
        label: "Email",
      },
      {
        id: ACTIVITY_TYPES.SMS,
        label: "SMS",
      },
      {
        id: ACTIVITY_TYPES.NOTES,
        label: "Notes",
      },
    ],
    []
  );

  const buttonsListItems = useMemo(
    () =>
      tabItems.map(({ id, label }) => ({
        label,
        onClick: () => handleTabChange(id),
        selected: activeTab === id,
      })),
    [tabItems, handleTabChange, activeTab]
  );

  return (
    <PageContainer>
      <ContentContainer>
        <TabSwitcherContainer>
          <ButtonsList items={buttonsListItems} size="medium" />
        </TabSwitcherContainer>
      </ContentContainer>
      <Routes>
        <Route path="/" element={<Navigate to="all" replace />} />
        <Route
          path="all"
          element={
            <All
              {...getTabProps(ACTIVITY_TYPES.ALL)}
              onPageChange={handlePageChange}
              onItemsPerPageChange={handleItemsPerPageChange}
              onRefresh={handleRefresh}
              handleGetNoteDetail={handleGetNoteDetail}
              handleUpdateNote={handleUpdateNote}
              handleDeleteNote={handleDeleteNote}
            />
          }
        />
        <Route
          path="email"
          element={
            <Email
              {...getTabProps(ACTIVITY_TYPES.EMAIL)}
              onPageChange={handlePageChange}
              onItemsPerPageChange={handleItemsPerPageChange}
              onRefresh={handleRefresh}
            />
          }
        />
        <Route path="calls" element={<Calls />} />
        <Route
          path="sms"
          element={
            <SMS
              {...getTabProps(ACTIVITY_TYPES.SMS)}
              onPageChange={handlePageChange}
              onItemsPerPageChange={handleItemsPerPageChange}
              onRefresh={handleRefresh}
            />
          }
        />
        <Route
          path="notes"
          element={
            <Notes
              {...getTabProps(ACTIVITY_TYPES.NOTES)}
              contactId={contactId}
              onPageChange={handlePageChange}
              onItemsPerPageChange={handleItemsPerPageChange}
              onRefresh={handleRefresh}
            />
          }
        />
      </Routes>
    </PageContainer>
  );
});

export default Activity;
